import { Component, Inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent {
  isAuthenticated: boolean | undefined;

  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth, private userService: UserService,private router: Router) { }
  async ngOnInit() {
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    var cookieValue: any = this.userService.getCookie();
    if (this.isAuthenticated) {
      const userClaims = await this.oktaAuth.getUser();
      this.userService.loadUserProfile(userClaims);
    }
    else if (cookieValue !== null && cookieValue !== undefined && cookieValue !== '') {
      this.userService.loadUserProfile(JSON.parse(cookieValue));
    }
  }
  loginPage(){
     this.router.navigateByUrl('/login');
  }
}
